import { useState, useRef } from 'react';
import { FaPlus } from "react-icons/fa";
import { Button } from 'primereact/button';
import './Share.css';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils'
import { InputTextarea } from 'primereact/inputtextarea';
// import { instance } from '../../../api';
import { shareFile } from '../../../Data/livrable_service';
export default function ShareFile({ livrableId,setDialogShare }) {
    
    const [formFields, setFormFields] = useState([])
    const [errorMail, setErrorEmail] = useState(false)
    // const [validEmail, setErrorValidEmail] = useState(false)
    const toast = useRef(null);
    const [message, setMessage] = useState(""); // State to hold the message input
    const [isVisible, setIsVisible] = useState(true); // State to manage card visibility

    const handleFormChange = (event, index) => {
        let data = [...formFields];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
    }

    const submit = (e) => {
        e.preventDefault();
        // // console.log('data', data)
        // // const formData = new FormData();
        // formFields.forEach(email => {
        //     // formData.append('emails[]', email.email);
           
        //     if (!email.email) {
        //         setErrorEmail(true)
              
        //     }
        //     else setErrorEmail(false)

        // });
        const emails = formFields.map(email => email.email);
        const data = {
            emails: emails,
            message: message, // Ajout du message dans les données

          };
        //   if (!emails.email) {
        //     setErrorEmail(true)
          
        // }
        // else setErrorEmail(false)
     
            try {
            
                shareFile(livrableId,data)
               
                toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Le livrable est envoyé avec succès ', life: 3000 });
                  // Hide the card after a delay
            setTimeout(() => {
                setIsVisible(false);
                setDialogShare(false);
            }, 3000); // Adjust the delay (3000ms = 3 seconds)

        
               
            

            } catch (error) {

                console.error(error);

            }
        
    }
    // const validate = (data) => {
    //     let errors = {};

    //     if (!data.email) {
    //         errors.email = 'Ce champ est obligatoire.'
    //     }
    //     else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
    //         errors.email = 'adresse mail invalide. E.g. example@email.com';
    //     }

    //     return errors;
    // }

    const addFields = () => {
        let object = {}
        setFormFields([...formFields, object])
    }

    const removeFields = (index) => {
        let data = [...formFields];
        data.splice(index, 1)
        setFormFields(data)
    }

    return (
        <>
            <Toast ref={toast} />
            {isVisible && (
                <>
                    <div className="share" style={{ backgroundColor: "#c9cbcd" }}>
                        <Button onClick={addFields} className="AddEmail">
                            <FaPlus style={{ paddingRight: "1.5%" }} /> Ajouter un email
                        </Button>
                        <form onSubmit={submit}>
                            {formFields.map((form, index) => {
                                return (
                                    <div key={index}>
                                        <input
                                            className="fieldEmail"
                                            name="email"
                                            placeholder="email"
                                            onChange={(event) =>
                                                handleFormChange(event, index)
                                            }
                                            value={form.name}
                                        />
                                        
                                        <div
                                            className={
                                                errorMail ? "show" : "Notshow"
                                            }
                                            style={{ paddingLeft: "30px" }}
                                        >
                                            Adresse email réquis
                                        </div>
                                    </div>
                                );
                            })}
                        </form>
    
                        <br />
                        {formFields.length > 0 && (
                            <div className="message-and-send">
                                <span
                                    className="p-float-label p-input-icon-right"
                                    style={{ width: "100%" }}
                                >
                                    <InputTextarea
                                        id="Contenu"
                                        value={message}
                                        onChange={(e) =>
                                            setMessage(e.target.value)
                                        }
                                        placeholder="Écrivez ici..."
                                        autoResize
                                        className={classNames({
                                            "p-invalid": !message,
                                        })}
                                        style={{
                                            width: "91%",
                                            margin: "2%",
                                            paddingRight: "30%",
                                            maxHeight: "90px",
                                            overflowY: "auto",
                                              
                                        }}
                                    />
                                    <label
                                        htmlFor="Contenu"
                                        style={{
                                            width: "91%",
                                            margin: "2%",
                                            paddingRight: "30%",
                                        }}
                                    >
                                        Écrivez ici *
                                    </label>
                                </span>
                                <Button onClick={submit} className="SendBtn">
                                    Envoyer
                                </Button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
    
}